import { render } from "./RotateHandler.vue?vue&type=template&id=b99d8dae&scoped=true"
const script = {}

import "./RotateHandler.vue?vue&type=style&index=0&id=b99d8dae&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99d8dae"]])

export default __exports__